import { render, staticRenderFns } from "./AddCampaignKeywordGrid.vue?vue&type=template&id=8c20e4d8"
import script from "./AddCampaignKeywordGrid.vue?vue&type=script&lang=js"
export * from "./AddCampaignKeywordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports